module.exports = __webpack_public_path__ + "static/media/low_battery_f1.6299905a.svg";